import React from "react";
import styles from "./Logo.module.scss";

export const Logo: React.FunctionComponent = () => {
  const cx = 50;
  const cy = 50;
  const r = 50;
  const d = `M ${cx} ${cy}
    m ${r}, 0
    a ${r},${r} 0 1,0 -${r * 2} ,0
    a ${r},${r} 0 1,0 ${r * 2} ,0`;

  const v = `M29 28 L43 57 L46 48 L37 28Z M46 64 L50 74 L68 28 L60 28Z`;
  const final = d.concat(v);

  return (
    <div className={styles.wrapper}>
      {/* <div className={styles.bg}>
        <Image src="/images/logo_2904 x905.jpg" ratio={2904 / 905} alt="" />
      </div> */}

      <div className={styles.svg}>
        <svg viewBox="0 0 100 100">
          <path d={final} fillRule="evenodd" />
        </svg>
      </div>
    </div>
  );
};
